import React from 'react';
import { ChevronDown } from 'lucide-react';

const StatusSelect = ({ value, onChange }) => {
  return (
    <div className="flex items-center justify-center">
      <div className="relative">
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="border border-solid border-border-tertiary rounded-sm h-8 pl-2 pr-8 text-gray-600 text-xs bg-white outline-none cursor-pointer min-w-[80px] appearance-none">
          <option value={1}>Registered</option>
          <option value={2}>Active</option>
          <option value={3}>Deactive</option>
          <option value={0}>Suspended</option>
        </select>
        <ChevronDown className="absolute right-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-600 pointer-events-none" />
      </div>
    </div>
  );
};

export default StatusSelect;
